import { TableCell, TableHeadCell } from "@rothoblaas/design-system";
import { FC } from "react";
import useI18n from "../../hooks/useTranslations";
import { PendingUser } from "../../http/types/pendingUsers";
import { usePendingUsersApi } from "../../http/usePendingUsers";
import AdminCrudTable from "../ui/AdminCrudTable";
import PendingUserModal from "./PendingUserModal";

// The users given roles and permissions by email before their first login (added from the users page).
const AdminPendingUsers: FC = () => {
  const i18n = useI18n();
  const t = i18n.translation.users.pending;
  const pendingUsersApi = usePendingUsersApi();

  return (
    <AdminCrudTable<PendingUser>
      filterPrefix="pending"
      useList={pendingUsersApi.usePendingUsers}
      head={
        <>
          <TableHeadCell align="left">{i18n.translation.common.email}</TableHeadCell>
          <TableHeadCell align="left">{i18n.translation.roles.plural}</TableHeadCell>
          <TableHeadCell align="left">{i18n.translation.permissions.plural}</TableHeadCell>
          <TableHeadCell align="left">{t.createdAt}</TableHeadCell>
        </>
      }
      renderRow={(item) => (
        <>
          <TableCell>{item.email}</TableCell>
          <TableCell>{item.roles.join(", ")}</TableCell>
          <TableCell>{item.permissions.join(", ")}</TableCell>
          <TableCell>{new Date(item.createdAt).toLocaleDateString()}</TableCell>
        </>
      )}
      renderForm={(item, onClose) => <PendingUserModal pendingUser={item} onClose={onClose} />}
      onDelete={(item) => pendingUsersApi.deletePendingUser(item.id)}
      deleteTitle={t.delete}
    />
  );
};

export default AdminPendingUsers;
